import { ChatbotRepository } from "../../../repositories/chatbot/chatbot.repository";
import type { IChatbotRepository } from "../../../repositories/chatbot/chatbot.repository.interface";
import type { IChatbotPromptService } from "./chatbot-prompt.service.interface";

export class ChatbotPromptService implements IChatbotPromptService {
  constructor(private readonly _chatbotRepository: IChatbotRepository = new ChatbotRepository()) {}

  public async storePrompt(prompt: string): Promise<void> {
    await this._chatbotRepository.storePrompt(prompt);
  }
}
